import React from 'react';
import { useTranslation } from 'react-i18next';

import { validateOrShowError } from 'utils/validators';
import { PasswordEndAdornment } from 'components/Inputs/PasswordEndAdornment';

import { StandardInput } from './Inputs';

const ConfirmPasswordInput = ({
  register,
  errors,
  name = 'confirmPassword',
  comparedInputName,
  label,
  watch,
  ...rest
}) => {
  const { t, ready } = useTranslation(['inputs']);
  const [showPassword, setShowPassword] = React.useState(false);

  const baseName = 'inputs:errors';
  if (!ready) return null;

  return (
    <>
      <StandardInput
        inputRef={register({
          required: { value: true, message: t(`${baseName}.required`) },
          validate: (value) =>
            validateOrShowError(
              value,
              (value) => value === watch(comparedInputName),
              t(`${baseName}.confirm-password`)
            ),
        })}
        label={label}
        type={showPassword ? 'text' : 'password'}
        errorMessage={errors[name]?.message}
        error={!!errors[name]}
        name={name}
        endAdornment={
          <PasswordEndAdornment
            showPassword={showPassword}
            setShowPassword={setShowPassword}
          />
        }
        {...rest}
      />
    </>
  );
};

export { ConfirmPasswordInput };
